import { render, staticRenderFns } from "./Shipping.vue?vue&type=template&id=052e479c&scoped=true"
import script from "./Shipping.vue?vue&type=script&lang=ts"
export * from "./Shipping.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052e479c",
  null
  
)

export default component.exports